import React from 'react'
import { URL_SRV_RAIZ } from '../router/Url';

function GetDataToShowTableDatos({empresa,MINIFECHA}) {
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_RAIZ+'getdatatotableshow',{
      method: 'POST',
      headers: {
        'authorization': "paico2021",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        empresa: empresa,
        MINIFECHA: MINIFECHA
      })
    })
    let responsito = await query.json();
    // console.log(responsito)
    if(responsito.data.success){
      resolve(responsito.data.body)
    }else{
      resolve([])
    }
  })
}

export default GetDataToShowTableDatos